import { render, staticRenderFns } from "./VMainPagination.vue?vue&type=template&id=ce87a5bc"
import script from "./VMainPagination.vue?vue&type=script&lang=js"
export * from "./VMainPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce87a5bc')) {
      api.createRecord('ce87a5bc', component.options)
    } else {
      api.reload('ce87a5bc', component.options)
    }
    module.hot.accept("./VMainPagination.vue?vue&type=template&id=ce87a5bc", function () {
      api.rerender('ce87a5bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commons/VMainPagination.vue"
export default component.exports